<div class="ct-page">
  <div class="ct-content">

    <app-diagnostic-form [loading]="loading" [country]="storeAux.country" (submitted)="onSubmit($event)"></app-diagnostic-form>

    <!-- SSO pending -->
    <div *ngIf="loading && ssoUrl" class="ct-banner ct-banner--warning">
      <div class="ct-banner__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
      </div>
      <div class="ct-banner__body">
        <div class="ct-banner__label">Autenticación Snowflake requerida</div>
        <h2 class="ct-banner__title">Hace falta completar el SSO de Snowflake para continuar.</h2>
        <p class="ct-banner__desc">Abre el link en una pestaña nueva, autentícate con tu cuenta, y el diagnóstico se reanuda automáticamente.</p>
        <a [href]="ssoUrl" target="_blank" rel="noopener noreferrer"
           class="rp-button rp-filled rp-primary rp-small ct-banner__btn">
          Abrir SSO de Snowflake
          <svg viewBox="0 0 20 20" fill="currentColor" style="width:14px;height:14px;margin-left:6px">
            <path d="M11 3a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 1 0 1.414 1.414L15 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1h-5z"/>
            <path d="M5 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v3H5V7h3a1 1 0 0 0 0-2H5z"/>
          </svg>
        </a>
      </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="loading" class="ct-loading">
      <mat-progress-bar mode="indeterminate" class="rp-loading-bar"></mat-progress-bar>
      <div class="ct-loading__text">
        <p class="ct-loading__title">Analizando campaña</p>
        <p class="ct-loading__desc">Consultando Snowflake — esto puede tardar unos minutos</p>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="error" class="ct-banner ct-banner--error">
      <div class="ct-banner__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      </div>
      <div class="ct-banner__body">
        <div class="ct-banner__label">Error</div>
        <p class="ct-banner__desc ct-banner__desc--error">{{ error }}</p>
        <button type="button" class="rp-button rp-outlined rp-accent rp-small" (click)="onRetry()">
          <svg viewBox="0 0 20 20" fill="currentColor" style="width:12px;height:12px;margin-right:4px">
            <path fill-rule="evenodd" d="M15.312 11.424a5.5 5.5 0 0 1-9.201 2.466l-.312-.311h2.433a.75.75 0 0 0 0-1.5H3.989a.75.75 0 0 0-.75.75v4.242a.75.75 0 0 0 1.5 0v-2.43l.31.31a7 7 0 0 0 11.712-3.138.75.75 0 0 0-1.449-.39Zm1.23-3.723a.75.75 0 0 0 .219-.53V2.929a.75.75 0 0 0-1.5 0V5.36l-.31-.31A7 7 0 0 0 3.239 8.188a.75.75 0 1 0 1.448.389A5.5 5.5 0 0 1 13.89 6.11l.311.31h-2.432a.75.75 0 0 0 0 1.5h4.243a.75.75 0 0 0 .53-.219Z" clip-rule="evenodd"/>
          </svg>
          Reintentar
        </button>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && !error && !result" class="ct-empty">
      <div class="ct-empty__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
      </div>
      <h3 class="ct-empty__title">Sin diagnóstico aún</h3>
      <p class="ct-empty__desc">Ingresa un <code>Campaign ID</code> y el prefijo de país para inspeccionar el estado de entrega.</p>
    </div>

    <!-- Diagnosis result (early_exit or completed) -->
    <app-early-exit-card *ngIf="result" [data]="result"></app-early-exit-card>

  </div>
</div>
